import axios from "axios";
import type { RankOption, ReligionOption } from "gsintegrations";
import { API_BASE_URL, axiosClient } from "../api/axiosClient";

const RELIGION_ENDPOINT = `${API_BASE_URL}/religion`;

export const religionRepository = {
  async getReligions(): Promise<ReligionOption[]> {
    try {
      // x-skip-refresh: Religion data is public reference data fetched during
      // onboarding before the user has auth cookies. If the response is ever
      // 401, skip the interceptor's refresh-and-redirect flow.
      const response = await axiosClient.get(`/religion`, {
        withCredentials: true,
        headers: { "x-skip-refresh": "1" },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Religion fetch error details:", {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          url: RELIGION_ENDPOINT,
        });
      } else {
        console.error("Religion fetch error details:", {
          message: String((error as Error)?.message || error),
          url: RELIGION_ENDPOINT,
        });
      }
      throw error;
    }
  },
  async getRanksByReligionId(religionId: string): Promise<RankOption[]> {
    try {
      const response = await axiosClient.get(`/religion/${religionId}/ranks`, {
        withCredentials: true,
        headers: { "x-skip-refresh": "1" },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Religion ranks fetch error details:", {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          url: RELIGION_ENDPOINT,
        });
      } else {
        console.error("Religion ranks fetch error details:", {
          message: String((error as Error)?.message || error),
          url: RELIGION_ENDPOINT,
        });
      }
      throw error;
    }
  },
};
